module.exports = __webpack_public_path__ + "static/media/01.38d684ee.jpg";